var moment = require('moment');

const eventHelpers = {
    formatRepeats(event) {
        if (!event.event_repeats || event.event_repeats.length === 0) return "";

        const locale = this.$i18n ? this.$i18n.locale : "en";

        // Group weekly and monthly separately
        const weeklyDays = [];
        const monthlyDays = [];

        event.event_repeats.forEach(repeat => {
            if (repeat.repeat === "weekly") {
                const weekday = moment().locale(locale).day(parseInt(repeat.day, 10)).format("dddd");
                weeklyDays.push(weekday);
            }

            if (repeat.repeat === "monthly") {
                const dayNum = parseInt(repeat.day, 10);
                const now = moment().locale(locale).date(dayNum);
                monthlyDays.push(now.format("MMM D")); // e.g. "Sep 4"
            }
        });

        let parts = [];

        if (weeklyDays.length) {
            let weeklyStr;
            if (weeklyDays.length === 1) {
                weeklyStr = `${this.$t("every")} ${weeklyDays[0]}`;
            } else {
                weeklyStr = `${this.$t("every")} ${weeklyDays.slice(0, -1).join(", ")} ${this.$t("and")} ${weeklyDays.slice(-1)}`;
            }
            parts.push(weeklyStr);
        }

        if (monthlyDays.length) {
            parts.push(monthlyDays.join(", "));
        }

        return parts.join(" | ");
    },

    formatDate(startEpoch, endEpoch = null) {
        if (!startEpoch) return "";

        const locale = this.$i18n ? this.$i18n.locale : undefined;

        const start = new Date(startEpoch * 1000); // seconds → ms
        const now = new Date();
        const end = endEpoch ? new Date(endEpoch * 1000) : null;

        // Ongoing event
        if (end && now >= start && now <= end) {
            const sameDay = now.toUTCString().slice(0, 16) === end.toUTCString().slice(0, 16);
            if (sameDay) {
                return `${this.$t('today')}`;
            } else {
                const endStr = end.toLocaleDateString(locale, {
                    day: "numeric",
                    month: "short",
                    timeZone: "UTC"
                });
                return `${this.$t('until')} ${endStr}`;
            }
        }

        // Work with UTC calendar dates
        const target = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
        const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        const diffDays = Math.round((target - today) / (1000 * 60 * 60 * 24));

        let dayStr;
        if (diffDays === 0) dayStr = this.$t('today');
        else if (diffDays === 1) dayStr = this.$t('tomorrow');
        else if (diffDays > 1 && diffDays <= 7) {
            dayStr = start.toLocaleDateString(locale, { weekday: "long", timeZone: "UTC" });
        } else {
            dayStr = start.toLocaleDateString(locale, { day: "2-digit", month: "short", timeZone: "UTC" });
        }

        const timeStr = start.toLocaleTimeString(locale, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,   // force 24-hour clock
            timeZone: "UTC"
        });

        return `${dayStr} - ${timeStr}`;
    },

    formatEventItems(event) {
        if (!event || !event.next_occurrence) return "";

        const next = event.next_occurrence;

        // Convert to Date if needed
        const firstDate = next.date instanceof Date ? next.date : new Date(next.date);
        const endDate = next.end ? (next.end instanceof Date ? next.end : new Date(next.end)) : null;

        // Determine the day string (today/tomorrow/weekday/short date)
        const dateStr = this.getRelativeDayName(firstDate, endDate);

        // Force 24h GMT time
        const timeStr = firstDate.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "UTC"
        });
        return `${dateStr} - ${timeStr}`;
    },
}

export default eventHelpers;
